import { StatusDot } from '../chrome/Icon';
import { useT } from '../../i18n';
import type { MilestoneStatus } from '../../data/types';

interface Props {
  status: MilestoneStatus;
  /** Optional legacy props — colour now flows from the --color-accent CSS var. */
  accent?: string;
  accentInk?: string;
}

/**
 * Status chip used everywhere we surface a milestone's state.
 * Colours derive from the active accent CSS var, so this works for any preset.
 */
export function StatusPill({ status }: Props) {
  const t = useT();
  if (status === 'done') {
    return (
      <span
        className="inline-flex items-center gap-1.5 rounded-full pl-2 pr-2.5 py-1.5 text-[11.5px] font-semibold tracking-wide text-accent-ink whitespace-nowrap"
        style={{ background: 'color-mix(in oklch, var(--color-accent) 12%, var(--color-bg))' }}
      >
        <StatusDot status="done" color="var(--color-accent)" />
        {t('status.achieved', 'Achieved')}
      </span>
    );
  }
  if (status === 'now') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-soft pl-2 pr-2.5 py-1.5 text-[11.5px] font-semibold tracking-wide text-amber-ink whitespace-nowrap">
        <StatusDot status="now" color="var(--color-accent)" />
        {t('status.inProgress', 'In progress')}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-grey-soft pl-2 pr-2.5 py-1.5 text-[11.5px] font-semibold tracking-wide text-ink-2 whitespace-nowrap">
      <StatusDot status="soon" color="var(--color-accent)" />
      {t('status.upcoming', 'Upcoming')}
    </span>
  );
}
